
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sandbox/ros-preview-sandbox",
      function () {
        return require("private-next-pages/sandbox/ros-preview-sandbox.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sandbox/ros-preview-sandbox"])
      });
    }
  